import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randProductName, randNumber, randChanceBoolean } from '@ngneat/falso'
import type { BundleNavigationSearchData } from '@/composables/api/NavigationSearch.js'
import { toNumber } from '@/utils/number.js'

type BundleNavigationSearch = Omit<BundleNavigationSearchData, 'id'> & {
  id?: number
}
export const model = Model as ModelDefinition<BundleNavigationSearch>

export const factory = Factory.extend<BundleNavigationSearch>({
  name() {
    return `${randProductName()} Bundle`
  },
  price() {
    return randNumber({ min: 50, max: 1000, fraction: 2 })
  },
  price_fixed() {
    if (randChanceBoolean({ chanceTrue: 0.3 })) {
      return toNumber(this.price)
    }
    return null
  },
  price_starting_from() {
    if (!this.price_fixed) {
      return toNumber(this.price)
    }
    return null
  },
})
